import { apiSlice } from './apiSlice';
import { DAILYSTORESTOCKS_URL } from '../constants';

export const dailyStoreStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new dailyStoreStock
    createDailyStoreStock: builder.mutation({
      query: (dailyStoreStock) => ({
        url: DAILYSTORESTOCKS_URL,
        method: 'POST',
        body: dailyStoreStock,
      }),
    }),

    // Get dailyStoreStock details by ID
    getDailyStoreStockDetails: builder.query({
      query: (id) => ({
        url: `${DAILYSTORESTOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's dailyStoreStocks
    getMyDailyStoreStocks: builder.query({
      query: () => ({
        url: `${DAILYSTORESTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all dailyStoreStocks (Admin)
    getDailyStoreStocks: builder.query({
      query: () => ({
        url: DAILYSTORESTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark dailyStoreStock as delivered
    deliverDailyStoreStock: builder.mutation({
      query: (dailyStoreStockId) => ({
        url: `${DAILYSTORESTOCKS_URL}/${dailyStoreStockId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete dailyStoreStock
    deleteDailyStoreStock: builder.mutation({
      query: (dailyStoreStockId) => ({
        url: `${DAILYSTORESTOCKS_URL}/${dailyStoreStockId}`,
        method: 'DELETE',
      }),
    }),

    // Update dailyStoreStock (FIXED)
    updateDailyStoreStock: builder.mutation({
      query: ({ dailyStoreStockId, ...body }) => ({
        url: `${DAILYSTORESTOCKS_URL}/${dailyStoreStockId}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useCreateDailyStoreStockMutation,
  useGetDailyStoreStockDetailsQuery,
  useGetMyDailyStoreStocksQuery,
  useGetDailyStoreStocksQuery,
  useDeliverDailyStoreStockMutation,
  useDeleteDailyStoreStockMutation,
  useUpdateDailyStoreStockMutation,
} = dailyStoreStocksApiSlice;
